import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

window.Swiper = Swiper;

class AnnouncementBar extends HTMLElement {
    constructor() {
        super();
        this.swiper = null
        this.swiperElement = null;
    }


    connectedCallback() {
        this.swiperElement = this.querySelector('.swiper');
        this.autoplayValue = Number(this.swiperElement.getAttribute('data-autoplay'));

        console.log('this.autoplayValue', this.autoplayValue);

        if (this.autoplayValue !== 0) {
            this.autoplayValue = this.autoplayValue * 1000;
            this.autoplaySettings = {
                delay: this.autoplayValue,
                disableOnInteraction: false,
                waitForTransition: true,
            }
        } else {
            this.autoplaySettings = 'false';
        }

        this.swiperOptions = {
            modules: [
                Autoplay,
                Navigation
            ],
            slidesPerView: 1,
            // centeredSlides: true,
            speed: 200,
            maxBackfaceHiddenSlides: 0,
            loop: true,
            autoplay: this.autoplaySettings,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };

        setTimeout(() => {
            this.swiper = new Swiper(this.swiperElement, this.swiperOptions);
            console.log('this.swiper', this.swiper);
        }, 1000);
    }
}

customElements.define('announcement-bar', AnnouncementBar);